import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, OnInit, Pipe, PipeTransform, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import * as XLSX from 'xlsx';
import { EnterpriseService } from 'src/app/services/enterprise/enterprise.service';
import { GatewayService } from 'src/app/services/gateway/gateway.service';
import { HeadquarterService } from 'src/app/services/headquarter/headquarter.service';
import { PanelIOTService } from 'src/app/services/panel-iot/panel-iot.service';
import { SensorService } from 'src/app/services/sensor/sensor.service';
import { ZoneService } from 'src/app/services/zone/zone.service';
import { PanelSensorModalComponent } from 'src/app/shared/components/modals/panel-sensor-modal/panel-sensor-modal.component';
import { SensorModalComponent } from 'src/app/shared/components/modals/sensor/sensor-modal.component';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import { AlertService, MessageSeverity } from 'src/app/shared/services/alert.service';
import { EmitterService } from 'src/app/shared/services/emitter.service';
import { environment } from 'src/environments/environment';
import 'fabric';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
declare const fabric: any;
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { Router } from '@angular/router';
import { ActuatorDetailPanelModalComponent } from 'src/app/shared/components/modals/actuator-detail-panel-modal/actuator-detail-panel-modal.component';
import { ActuatorService } from 'src/app/services/actuator/actuator.service';
import * as signalR from '@microsoft/signalr';
import { PanelIotActionModalComponent } from 'src/app/shared/components/modals/panel-iot-action-modal/panel-iot-action-modal.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
@Component({
  selector: 'app-panel-iot',
  templateUrl: './panel-iot.component.html',
  styleUrls: ['./panel-iot.component.css']
})

export class PanelIotComponent implements OnInit {
  @ViewChild('excelTable', { static: false }) excelTable: ElementRef;

  loading: boolean = false;
  dataSource = new MatTableDataSource();
  displayedColumns: string[] = ['enterprise','headquarter','gateway','name','description','nomenclature','action'];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  isAdminGys: boolean = false;
  countMaxUserByEnterprise: number = 0;
  enterprises = [];
  headquarters = [];
  gateways = [];
  subscription: Subscription;
  enterpriseSelect: number = 0;
  pageEvent: PageEvent;
  pageIndex: number = 0;
  pageSize: number = AppConstants.Paginado.DEFAULT_PAGE_SIZE_PAGINATION;
  length: number = 0;
  page: number = 1;
  showTypeSelect = "3";
  headquarterSelect: number = 0;
  gatewaySelect: number = 0;
  zones = [];
  isPoza = false;
  zoneSelect: number = 0;
  canvas: any;
  nameMarker: string = '';
  sensors = [];
  paneliotSearch = [];
  selectedPanelIOT = [];
  checkedGrafica = false;
  checkedTabla = false;
  checkedMapa = false;
  showSensorEdit = false;
  showGraphSensor = false;
  showSensorsGraphs = false;
  showLavelSensorsTable:boolean = false;
  displayListStadistics = 'none';
  dataStreaming = [];
  dataStreamingColumn = [];
  dataStreamingColumnSensorsInit = [];
  dataStreamingColumnSensors = [];
  dataStreamingColumnActuators = [];
  colorToggle = "";
  imageZone = "";
  initPage = false;
  private _hubConnection: HubConnection;
  color1: string;
  color2: string;
  colorFont: string;
  colorFont2: string;
  guardTotal = "";
  guardTotalTQ ="";
  contentTotal ="";
  isGuardTotal = false;
  enabledRead: number;
  enabledWrite: number;
  editSetting = false;
  isPhone = false;
  loadData = false;
  isTank = false;
  maxCapacityPoza = "";
  nowCapacityPoza = "";
  enabledCapacityPoza = "";
  percentageMaxCapacityPoza = 0;
  percentageNowCapacityPoza = 0;
  percentageEnabledCapacityPoza = 0;
  selectSensorMenu = 0;
  dropdownSettings:IDropdownSettings;
  filterIOT = [];
  qtyEnabled = 0;
  qtyDisabled = 0;
  sensorTypesCountEnabled = [];
  showGraphSensorPanel = false;
  sensorTypesCountDisabled = [];
  sensorTypesCountEnabledObj= new Map<String, String>();
  sensorTypesCountDisabledObj= new Map<String, String>();
  test = new EventEmitter<number>();
  showAllHeadquarters = true;
  constructor(
    public dialog: MatDialog,
    private alertService: AlertService,
    private changeDetector: ChangeDetectorRef,
    private enterpriseService: EnterpriseService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private actuatorService: ActuatorService,
    private headquarterService: HeadquarterService,
    private gatewayService: GatewayService,
    private panelIOTService: PanelIOTService,
    private zoneService: ZoneService
    ) {
      document.getElementById("titleHeaderNav").innerHTML = 'IOT > <span class="font-weight-bold">Panel de Actuadores y Sensores</span>';
      const userAgent: string = navigator.userAgent || navigator.vendor;
      const isMobileDevice = (): boolean => {
        const regexs = [/(Android)(.+)(Mobile)/i, /BlackBerry/i, /iPhone|iPod/i, /Opera Mini/i, /IEMobile/i]
        return regexs.some((b) => userAgent.match(b))
      }
      this.isPhone = isMobileDevice();
      this.dropdownSettings = {
        singleSelection: false,
        idField: 'id',
        textField: 'sensor',
        tooltipField: 'Sensor',
        selectAllText: 'Todos',
        unSelectAllText: 'Limpiar',
        searchPlaceholderText: 'Buscar',
        noFilteredDataAvailablePlaceholderText: 'Item no encontrado',
        itemsShowLimit: 6,
        allowSearchFilter: true, //input search
      };

        var _this = this;
        const connection = new signalR.HubConnectionBuilder()
        .withUrl(environment.fnIOT + '/api')
        .withAutomaticReconnect()
        .configureLogging(signalR.LogLevel.Information)
        .build();

        if(_this.showTypeSelect == '1'){
          connection.on('eventHubIOT', (message) => {
            if(!_this.isPhone){
              _this.removeActuatorsSensors();
              _this.removeLabelValueSensors();
            }
            if(!_this.loadData){
              _this.getList();
            }
          });

          connection.start()
            .catch(console.error);
        }else{
          connection.stop().catch(console.error);
        }


          setInterval(()=>{
            _this.dataStreaming.forEach(x =>{
              if(x.idActuatorType == 1){
                var value = (Math.random() * (0.93 - 0.90) + 0.90).toFixed(3);
                var data = {
                  id: x.idActuator,
                  density: value
                }
                _this.actuatorService.updateDensity(data).subscribe(_ =>{});
              }
            });
            _this.removeActuatorsSensors();
            _this.removeLabelValueSensors();
            if(_this.showTypeSelect == '1'){
              _this.getList();
            }

          },300000);

      var enabledCapacityPoza = Math.floor(Math.random() * (6000 - 100 + 1)) + 100;
      this.maxCapacityPoza = "6000 TN";
      this.enabledCapacityPoza =  enabledCapacityPoza + " TN";
      this.nowCapacityPoza = (6000 - enabledCapacityPoza).toFixed(2) + " TN";
      this.percentageEnabledCapacityPoza = Math.round((enabledCapacityPoza*100)/6000);
      this.percentageNowCapacityPoza = 100 - this.percentageEnabledCapacityPoza;
   }

   offEdit(){
    this.editSetting = this.editSetting == true ? false : true;
    if(this.editSetting){
      this.showGraph();
    }
   }

   setLS(){
    this.color1 = localStorage.getItem(AppConstants.Session.THEME_COLOR1);
    this.color2 = localStorage.getItem(AppConstants.Session.THEME_COLOR2);
    this.colorFont = localStorage.getItem(AppConstants.Session.THEME_COLOR_FONT);
    this.colorFont2 = localStorage.getItem(AppConstants.Session.THEME_COLOR_FONT2);
    //validate Permisses menu
    var menu = JSON.parse(localStorage.getItem(AppConstants.Session.MENU));
    var page = this.router.url.split("/");
    var i = page[page.length-1];
    var itemTag = menu.filter(x => x.tag != null && (x.tag.toString()).toLowerCase().includes(i));
    if(itemTag.length>0){
      this.enabledRead = itemTag[0].activeRead;
      this.enabledWrite = itemTag[0].activeWrite;
    }else{
      this.enabledRead = 0;
      this.enabledWrite = 0;
    }
  }

  ngOnInit() {
    this.setLS();
    this.panelIOTService.setDataStreamingSensors([]);
    this.isAdminGys = (+localStorage.getItem(AppConstants.Session.ROLID) == AppConstants.UserRole.AdministradorGyS || +localStorage.getItem(AppConstants.Session.ROLID) == AppConstants.UserRole.UsuarioGyS) ? true : false;
    this.enterpriseSelect = (+localStorage.getItem(AppConstants.Session.ENTERPRISE));
    this.headquarterSelect = (+localStorage.getItem(AppConstants.Session.HEADQUARTER));
    this.getGuardTotalTQ();
    this.getZones();
   // this.getSensors();
    var _this = this;
   /*setInterval(function () {
      if(_this.showSensorsTable){
        _this.dataStreaming = _this.panelIOTService.getDataStreamingSensors();
        _this.removeValueSensors();
        _this.createValueSensor();
      }
    }, 1000);*/
  }

  ngAfterViewInit(): void {
    //this.getCanvas();
  }

  exportAsExcel() {
    /* table id is passed over here */
    let element = document.getElementById('excelTableId');
    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    var date = new Date();
    var downfileNameload = `panel_sensores_actuadores-${date}.xls`;
    XLSX.writeFile(wb, downfileNameload);
}


exportGraph24Hours(d:any){
  /* table id is passed over here */
  var labels = d.labels;
  var data = d.data;
  var list = [];
  let objectDate = new Date();
  let day = objectDate.getDate();
  console.log(day); // 23

  let month = objectDate.getMonth() + 1;

  let year = objectDate.getFullYear();
  console.log(year); // 2022
  var dia = day.toString();
  if (day < 10) {
    dia = '0' + day.toString();
  }
  var mes = month.toString();
  if (month < 10) {
     mes = `0${month}`;
  }
  let fecha = `${dia}/${mes}/${year}`;
  var ayer = new Date(objectDate.getTime() - (24 * 60 * 60 * 1000));
  let day2 = ayer.getDate();
  console.log(day2); // 23

  let month2 = ayer.getMonth()+ 1;

  let year2 = ayer.getFullYear();
  console.log(year2); // 2022
  var dia2 = day2.toString();
  if (day2 < 10) {
    dia2 = '0' + day2.toString();
  }
  var mes = month.toString();
  if (month2 < 10) {
     mes = `0${month}`;
  }
  let fechaAyer = `${dia2}/${mes}/${year2}`;
  var ddd = fechaAyer;
  var first0 = false;
  var exist0 = labels.filter(x => x == 0);
  for(var i = 0; i<25;i++)
  {
    console.log(labels[i]+ "  &&   "+ !first0 + "  && "+exist0.length);
    if(labels[i]==0 && !first0 && exist0.length == 1){  ddd = fecha; first0 = true; }
    else if(labels[i]==0 && !first0 && i > 0 && exist0.length == 2){  ddd = fecha; first0 = true; }
    list.push({
      Fecha: ddd,
      Hora: labels[i],
      Valor: data[i]
    });
  }

  ///const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
  const ws: XLSX.WorkSheet =XLSX.utils.json_to_sheet(list);
  /* generate workbook and add the worksheet */
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

  /* save to file */
  var date = new Date();
  var downfileNameload = `reporte_grafica_sensores_actuadores-${date}.xls`;
  XLSX.writeFile(wb, downfileNameload);
}

  setTheme(){
    this.color1 = localStorage.getItem(AppConstants.Session.THEME_COLOR1);
    this.color2 = localStorage.getItem(AppConstants.Session.THEME_COLOR2);
    this.colorFont = localStorage.getItem(AppConstants.Session.THEME_COLOR_FONT);
    this.colorFont2 = localStorage.getItem(AppConstants.Session.THEME_COLOR_FONT2);
  }

  onItemSelect(item: any) {

    this.filterIOT.push(item.id);
    /*this.dataStreamingColumnSensors = this.dataStreamingColumnSensorsInit.filter(
        _ => {
          return this.filterIOT.includes(_.id);
        }
      );

     this.dataStreaming = this.dataStreamingColumnSensorsInit.filter(
      _ => {
        return this.filterIOT.includes(_.id);
      }
    );  */
   //
   // if(this.showTypeSelect == '2'||this.showTypeSelect == '1'){
      this.getList();
    //}
  }

  onFilterChange(item: any){
    console.log("onFilterChange",item);
  }

  onDeSelect(item: any) {
    /*this.dataStreamingColumnSensors = this.dataStreamingColumnSensors.filter(
      _ => {
        return !this.filterIOT.includes(_.id) || _.id != item.id;
      }
    );

    this.dataStreaming = this.dataStreaming.filter(
      _ => {
        return !this.filterIOT.includes(_.id);
      }
    );*/
    console.log("select item ", item )
    console.log("select DEL ", this.filterIOT )
    this.filterIOT =this.filterIOT.filter(
      x => {
        return x != item.id
      }
    );
    this.getList();
  }

  onSelectAll(items: any) {
    if(this.filterIOT.length>0){
      this.filterIOT = [];
      console.log("onSelectAll",items);
    }

    /*if(items.length == 0){
      this.filterIOT = [];
    }else{
      console.log("dataStreamingColumnSensorsInit",this.dataStreamingColumnSensorsInit);
      this.filterIOT = this.dataStreamingColumnSensorsInit;
    }
    console.log("filterIOT onSelectAll",this.filterIOT);*/
    this.getList();
  }

  getSensors(){
    var filter = {
      idEnterprise: this.enterpriseSelect,
      idHeadquarter: this.headquarterSelect,
      idZone: this.zoneSelect,
      idGateway: this.gatewaySelect
    }
    this.spinner.show();
    this.selectedPanelIOT = [];
    this.panelIOTService.getList(filter).subscribe((_) => {
      this.sensors = [];
      if(_.error == null){
        var s = _.data;//.filter(x => x.stateSensor != "instalado");
        //console.log("sensors paneliotsearch",s);
        this.paneliotSearch=this.sensors.concat(s);
      }
      this.spinner.hide();
    });
  }

  getGuardTotalTQ(){
    this.actuatorService.getListAll(this.enterpriseSelect,this.headquarterSelect).subscribe((response) => {
      var actuators = response.data.filter(x => x.idActuatorType == 1);
      var totalguards = 0;
      actuators.forEach(x => {
        totalguards = totalguards + x.minCapacity;
      });
      this.guardTotalTQ = totalguards.toFixed(2);
    },
      (error: HttpErrorResponse) => {
        this.spinner.hide();
      });
  }

  showTable(event: MatSlideToggleChange){
    this.initPage = true;
    this.showLavelSensorsTable = event.checked;
    event.checked = this.showLavelSensorsTable ? false : true;
    if(!event.checked){
      this.createLabelValueSensors();
    }else{
      this.removeLabelValueSensors();
    }
  }

  showView(event: any){
    this.showTypeSelect = null;
    var panel = Number(event.value);
    this.showTypeSelect = panel.toString();
    if(panel==1){
      this.checkedGrafica = false;
      this.checkedTabla = false;
      this.checkedMapa = true;
      this.displayListStadistics = 'block';
      this.getZones();
    }else{
      if(panel==2){
        this.checkedGrafica = false;
        this.checkedTabla = true;
        this.checkedMapa = false;
        this.displayListStadistics = 'none';
      }else if(panel==3){
        this.checkedGrafica = true;
        this.checkedTabla = false;
        this.checkedMapa = false;
        this.displayListStadistics = 'none';
      }
      this.getList();
    }
  }

  showDetailSensor(item){
    var existZone = this.zoneSelect;
    this.zoneSelect = item.idZone;
    if(existZone == 0){
      this.getGateways();
    }
  }

  getCanvas() {
    this.canvas = new fabric.Canvas('canvas',{
      selection: true,
      allowTouchScrolling: true,
      enableRetinaScaling: true
    });
  }

  changeEnterprise(data) {
    this.countMaxUserByEnterprise = this.enterprises.find(f => f.enterpriseId == data.value).maximumUsers;
    this.enterpriseSelect = data.value;
    this.gatewaySelect = 0;
    this.headquarterSelect = 0;
    this.headquarters = [];
    this.gateways = [];
    this.getHeadquarters();
  }

  getEnterprises() {
    if (this.isAdminGys) {
      this.spinner.show();
      this.enterpriseService.getEnterprises().subscribe((response) => {
        this.enterprises = response.filter(f => f.enabled == AppConstants.Flag.Active);
        this.enterpriseSelect = this.enterprises[0]["enterpriseId"];
        this.spinner.hide();
        this.getHeadquarters();
      },
        (error: HttpErrorResponse) => {
          this.spinner.hide();
        });
    } else {
      this.enterpriseSelect = +localStorage.getItem(AppConstants.Session.ENTERPRISE)
      this.getEnterpriseById(this.enterpriseSelect);
      this.getList();
    }
  }

  getHeadquarters(){
    if (this.isAdminGys) {
      this.spinner.show();
      this.headquarterService.getListAll().subscribe((response) => {
        if(response.error == null){
          this.headquarters = response.data.filter(f => f.idEnterprise == this.enterpriseSelect);
          if(this.headquarters.length > 0){
            this.headquarterSelect = this.headquarters[0].id;
          }
          this.spinner.hide();
          this.getZones();
          this.getGateways();
        }else{
          this.headquarters = [];
          this.gateways = [];
          this.spinner.hide();
        }
      },
        (error: HttpErrorResponse) => {
          this.headquarters = [];
          this.gateways = [];
          this.spinner.hide();
        });
    } else {
      this.headquarterSelect = +localStorage.getItem(AppConstants.Session.HEADQUARTER);
    }
  }

  getGateways(){
    this.gatewayService.getListAll().subscribe((response) => {
      if(response.error == null){
        if(this.headquarterSelect == 0){
          var gateways = response.data.filter(x => x.idEnterprise == this.enterpriseSelect);
          this.gateways = gateways;
        }else{
          var gateways = response.data.filter(x => x.idEnterprise == this.enterpriseSelect && x.idHeadquarter == this.headquarterSelect);
          this.gateways = gateways;
        }
        if(this.gateways.length > 1){
          this.isGuardTotal = false;
          this.gatewaySelect = 0;
          this.guardTotal = "0";
        }else{
          this.isGuardTotal = this.gateways[0].isGuardTotal == 1 ? true : false;
          this.gatewaySelect = this.gateways[0].id;
          this.guardTotal = gateways[0].guardTotal.toFixed(2);
        }
      }else{
        this.gateways = [];
      }
      this.getList();
    },
      (error: HttpErrorResponse) => {
        this.gateways = [];
      });
  }

  showGuardTank(){
    let dialogRef = this.dialog.open(ActuatorDetailPanelModalComponent, {
      data: {
        title: AppConstants.TitleModal.LIST_ACTUATOR_PANEL_IOT,
        action: AppConstants.OperationType.UPDATE,
        headquarters: this.headquarters,
        idEnterprise: this.enterpriseSelect,
        idHeadquarter: this.headquarterSelect,
        idGateway: this.gatewaySelect,
        enabledWrite: this.enabledWrite,
        enabledRead: this.enabledRead,
        color: this.color1,
        colorFont: this.color2,
        obj:null},
      width: '500px',
      hasBackdrop: true
    });
    dialogRef.afterClosed().subscribe(_ => {
      if (_.result == true) {
        this.guardTotalTQ = _.totalguard;
      }
    });
  }

  getZones(){
    this.zoneService.getListAll(this.enterpriseSelect,this.headquarterSelect).subscribe((response) => {
      if(response.error == null){
        this.zones = response.data.filter(x => x.type == 2);
        if(this.zones.length>0){
          if(this.zoneSelect != 0){
            var zone = response.data.filter(x => x.id == this.zoneSelect);
            if(zone.length>0){
              this.zoneSelect = zone[0].id;
              var image = zone[0].image;
              this.imageZone = image;
              this.headquarterSelect = zone[0].idHeadquarter;
              this.getGateways();
            }
          }else{
            if(response.data.length == 1){
              this.zoneSelect = response.data[0].id;
              this.imageZone = response.data[0].image;
              this.headquarterSelect = response.data[0].idHeadquarter;
            }
            this.getGateways();
            /*this.zoneSelect = this.zones[0].id;
            var image2 = this.zones[0].image;
            this.imageZone = image2;

            if(this.showTypeSelect == '1'){
              this.changeImage(image2);
            }

            this.headquarterSelect = this.zones[0].idHeadquarter;
            this.getGateways();*/
          }


        } else {
          this.alertService.showMessage("No tiene zonas IOT registradas, debes de crear una zona para usar este módulo", "", MessageSeverity.error);
          if(this.showTypeSelect == '1'){
            this.changeImage('./assets/images/sin_image.jpg');
          }
        }
      }
    });
  }


  getEnterpriseById(enterpriseId: number) {
    this.spinner.show();
    this.enterpriseService.getEnterpriseById(enterpriseId).subscribe((response => {
      this.countMaxUserByEnterprise = response.maximumUsers;
      this.spinner.hide();
    }),
    (error: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  getGraphs(){
    var s = [];
    this.sensors.forEach(_ =>{
      s.push({
        Id: _.id,
        IdSensor: _.idSensor,
        Nomenclature : _.nomenclature,
        ValueType: _.valueType,
        Und: _.und,
        IndexGraphValueType: _.indexGraphValueType
      });
    });
    var _this = this;
    this.panelIOTService.getListGraphs({
      "Sensors":s
    }).subscribe((_) => {
      _this.dataStreamingColumnSensors.forEach(__ =>{
        var g = _.data.filter(x => x.id == __.id);
        if(g.length > 0){
          __.graphSensor = g[0].graphSensor;
          let sum = 0;
          /*if(__.graphSensor[0].LabelUnd == "Kwh"){
            __.graphSensor[0].DataSets[0].data.filter(y =>{
              sum = sum + parseFloat(y);
            });
          }else{
            __.graphSensor[0].DataSets[0].data.filter(y =>{
              sum = sum + parseFloat(y);
            });
          }*/
          __.graphSensor[0].DataSets[0].data.filter(y =>{
            console.log("y",y);
            sum = sum + parseFloat(y);
          });
          if(__.valueType == "Flujo"){
            let slash = __.und.indexOf("/");
            var und = __.und.substring(0, slash);
            console.log("item",__);
            if(__.valueSum24Hours != "-" && __.valueSum24Hours){
              console.log("__.valueSum24Hours: " + __.valueSum24Hours+ "||| und:"+und);
              __.valueSum24Hours = parseFloat(__.valueSum24Hours).toFixed(2) + " " + und;
            }
            __.valueAVG24Hours = (sum/24).toFixed(2) + " " + und;
          }else{
            __.valueSum24Hours = sum.toFixed(2) + " " + __.und;
            __.valueAVG24Hours = (sum/24).toFixed(2) + " " + __.und;
          }
        }
      });
      _this.dataStreamingColumnActuators.forEach(__ => {
        var g = _.data.filter(x => x.id == __.id);
        if(g.length > 0){
          __.graphSensor = g[0].graphSensor;
          let sum = 0;
          /*if(__.graphSensor[0].LabelUnd == "Kwh"){
            __.graphSensor[0].DataSets[0].data.filter(y =>{
              sum = sum + parseFloat(y);
            });
          }else{
            __.graphSensor[0].DataSets[0].data.filter(y =>{
              sum = sum + parseFloat(y);
            });
          }*/
          __.graphSensor[0].DataSets[0].data.filter(y =>{
            console.log("y",y);
            sum = sum + parseFloat(y);
          });
          if(__.valueType == "Flujo"){
            let slash = __.und.indexOf("/");
            var und = __.und.substring(0, slash);
            console.log("item",__);
            if(__.valueSum24Hours != "-" && __.valueSum24Hours){
              console.log("__.valueSum24Hours: " + __.valueSum24Hours+ "||| und:"+und);
              __.valueSum24Hours = parseFloat(__.valueSum24Hours).toFixed(2) + " " + und;
            }
            __.valueAVG24Hours = (sum/24).toFixed(2) + " " + und;
          }else{
            __.valueSum24Hours = sum.toFixed(2) + " " + __.und;
            __.valueAVG24Hours = (sum/24).toFixed(2) + " " + __.und;
          }
        }
      });
      _this.showGraphSensorPanel = true;
      //calculate sum y prom
      _this.dataStreamingColumnSensors.forEach(ds => {

      });
    });
  }

  getList(){
   // this.spinner.show();
      this.loadData = true;
      if(!this.isPhone && this.showTypeSelect == '1'){
        /*if(this.canvas != null){
          var objects = this.canvas.getObjects();
          console.log("objetcs",objects);
          for(var i = 0; i < objects.length; i++){
            this.canvas.remove(objects[i]);
          }
          this.canvas.objectCaching = false;
          this.canvas.requestRenderAll();
          this.canvas.renderAll();
          //this.canvas = null;
        }else{
          this.getCanvas();
        }*/
        this.getCanvas();
        console.log("zone",this.imageZone);
        this.changeImage(this.imageZone);
      }
      var filter = {
        idEnterprise: this.enterpriseSelect,
        idHeadquarter: this.headquarterSelect,
        idZone: this.zoneSelect,
        idGateway: this.gatewaySelect
      }
      var contentTotal = 0;
      this.dataStreaming = [];
      this.sensorTypesCountEnabled = [];
      this.sensorTypesCountDisabled = [];
      this.sensorTypesCountEnabledObj= new Map<String, String>();
      this.sensorTypesCountDisabledObj= new Map<String, String>();
      var repetidosEnabled = {};
      var repetidosDisabled = {};
      var _this = this;
      this.panelIOTService.getList(filter).subscribe((_) => {
        if(_.error == null){
          var d = _.data;
          if(this.filterIOT.length>0){
            d = _.data.filter(c =>{ return this.filterIOT.filter(x => x === c.id) });
          }

          this.qtyEnabled = d.filter(f => { return f.state == 1 }).length;
          this.qtyDisabled = d.filter(f => { return f.state != 1 }).length;
          var iii = 0;
          d.forEach(x =>{
            if(x.graphSensor == null || !x.graphSensor){
              x.graphSensor = {
                DataSets: []
              }
            }

            if(x.isActuator){ //Actuators
                if(x.idActuatorType == 1){ //TANQUE
                  this.isTank = true;
                  contentTotal += parseFloat(x.value);
                    var porc = Math.round((parseFloat(x.value)*100)/x.maxCapacity);
                    if(porc <= 0){
                      x.imgActuator = environment.storage + "/pin/actuator/Tanque1.png";
                    }else if(porc <= 25 && porc > 0){
                      x.imgActuator = environment.storage + "/pin/actuator/Tanque2.png";
                    }else if(porc <= 50 && porc > 25){
                      x.imgActuator = environment.storage + "/pin/actuator/Tanque3.png";
                    }else if(porc <= 75 && porc > 50){
                      x.imgActuator = environment.storage + "/pin/actuator/Tanque4.png";
                    }else if(porc <= 99 && porc > 75){
                      x.imgActuator = environment.storage + "/pin/actuator/Tanque5.png";
                    }else if(porc > 99){
                      x.imgActuator = environment.storage + "/pin/actuator/Tanque6.png";
                    }

                    if(x.state == 1){
                      this.sensorTypesCountEnabled.push(environment.storage + "/pin/actuator/Tanque6.png");
                    }else{
                      this.sensorTypesCountDisabled.push(environment.storage + "/pin/actuator/Tanque6.png");
                    }

                    x.imgDensity = environment.storage + "/actuator/density/aceite.png";
                    if(x.density < 0.90 && x.density > 0.93){
                      x.imgDensity = environment.storage + "/actuator/density/agua.png";
                    }


                  }else if(x.idActuatorType == 2){//valvula
                    x.imgActuator = environment.storage + "/pin/actuator/Valvula"+x.state+".png";
                    x.imgActuatorColumn = environment.storage + "/actuator/valvula/valvula_"+x.state+".png";
                  }else if(x.idActuatorType == 3){//poza
                    this.isPoza = true;
                     //(iii % 2 == 0) ? // : environment.storage + "/actuator/poza/Pozas_0.png";
                     // "/actuator/poza/Pozas_0.png";
                    //x.imgActuator = environment.storage + "/pin/actuator/Valvula"+x.state+".png";
                    //x.imgActuatorColumn = environment.storage + "/actuator/valvula/valvula_"+x.state+".png";
                    x.enableCapacity = (x.maxCapacity - x.avgSumSensors).toFixed(2);
                    var porc = Math.round((x.avgSumSensors*100)/x.maxCapacity);
                    x.percentageAvgSumSensors = porc;
                    x.percentageEnableCapacity = 100-porc;
                    var imgPor = 0;
                    if(porc <= 0){
                      imgPor = 0;
                    }else if(porc <= 25 && porc > 0){
                      imgPor = 25;
                    }else if(porc <= 50 && porc > 25){
                      imgPor = 50;
                    }else if(porc <= 75 && porc > 50){
                      imgPor = 75;
                    }else if(porc <= 99 && porc > 75){
                      imgPor = 99;
                    }else if(porc > 99){
                      imgPor = 100;
                    }
                    x.imgActuator = environment.storage + "/actuator/poza/Pozas_"+imgPor+".png";
                    x.imgActuatorColumn = environment.storage + "/actuator/poza/Pozas_"+imgPor+".png";
                    var array1 = Array.from({length: 25}, () => Math.floor(Math.random() * (x.maxCapacity - x.maxCapacity + 1)) + x.maxCapacity);
                    var array2 = Array.from({length: 25}, () => Math.floor(Math.random() * (800 - 600 + 1)) + 600);
                    var array3 = Array.from({length: 25}, () => Math.floor(Math.random() * (500 - 150 + 1)) + 150);
                    x.graphSensor = {
                      LabelUnd: "TN",
                      LabelValueMax: 1300,
                      LabelValueMin: 0,
                      LabelY: "Valores",
                      DataSets: [
                        {
                            "label": "Capacidad Máx",
                            "Und": "TN",
                            "data": array1,
                            "fill": false,
                            "labels": [
                                9,
                                10,
                                11,
                                12,
                                13,
                                14,
                                15,
                                16,
                                17,
                                18,
                                19,
                                20,
                                21,
                                22,
                                23,
                                0,
                                1,
                                2,
                                3,
                                4,
                                5,
                                6,
                                7,
                                8,
                                9
                            ],
                            "borderColor": "blue",
                            "backgroundColor": "blue",
                            "value": "78.1"
                        },
                        {
                            "label": "Capacidad Actual",
                            "Und": "TN",
                            "data": array2,
                            "fill": false,
                            "labels": [
                                9,
                                10,
                                11,
                                12,
                                13,
                                14,
                                15,
                                16,
                                17,
                                18,
                                19,
                                20,
                                21,
                                22,
                                23,
                                0,
                                1,
                                2,
                                3,
                                4,
                                5,
                                6,
                                7,
                                8,
                                9
                            ],
                            "borderColor": "red",
                            "backgroundColor": "red",
                            "value": "69.2"
                        },
                        {
                            "label": "Capacidad Disponible",
                            "Und": "A",
                            "data": array3,
                            "fill": false,
                            "labels": [
                                9,
                                10,
                                11,
                                12,
                                13,
                                14,
                                15,
                                16,
                                17,
                                18,
                                19,
                                20,
                                21,
                                22,
                                23,
                                0,
                                1,
                                2,
                                3,
                                4,
                                5,
                                6,
                                7,
                                8,
                                9
                            ],
                            "borderColor": "green",
                            "backgroundColor": "green",
                            "value": "63.9"
                        }
                      ],
                      Labels: [
                      9,
                      10,
                      11,
                      12,
                      13,
                      14,
                      15,
                      16,
                      17,
                      18,
                      19,
                      20,
                      21,
                      22,
                      23,
                      0,
                      1,
                      2,
                      3,
                      4,
                      5,
                      6,
                      7,
                      8,
                      9
                      ]
                    }

                  }

          }else{ //SENSORS
            if(x.nomenclatureSensorType == 'N'){
              x.imgSensorColumn = environment.storage + "/sensor/radar/radar.png";
            }

            if(x.nomenclatureSensorType == 'EE'){
                if(x.value== null){
                  x.percentContent = 0;
                  x.imageGaugePercentContent = environment.storage + "/sensor/gauges/GaugeAmp1.png";
                }else{
                  var porc = parseFloat(x.value);
                  var porce = Math.round((parseFloat(x.value)*100)/6000);
                  x.percentContent = porce;
                    /*if(porc <= 0){
                      x.imageGaugePercentContent = environment.storage + "/sensor/gauges/GaugeAmp1.png";
                    }else if(porc <= 1500 && porc > 0){
                      x.imageGaugePercentContent = environment.storage + "/sensor/gauges/GaugeAmp2.png";
                    }else if(porc <= 2250 && porc > 1500){
                      x.imageGaugePercentContent = environment.storage + "/sensor/gauges/GaugeAmp3.png";
                    }else if(porc <= 3750 && porc > 2250){
                      x.imageGaugePercentContent = environment.storage + "/sensor/gauges/GaugeAmp4.png";
                    }else if(porc <= 5000 && porc > 3750){
                      x.imageGaugePercentContent = environment.storage + "/sensor/gauges/GaugeAmp5.png";
                    }else if(porc > 99){
                      x.imageGaugePercentContent = environment.storage + "/sensor/gauges/GaugeAmp6.png";
                    }*/
                    x.imageGaugePercentContent = "../../../../../assets/pin-map/Cosa1.png";
                    var sum = 0;
                    /*if(x.graphSensor != null){
                      var und = x.graphSensor[0].DataSets[0].Und;
                      x.graphSensor[0].DataSets[0].data.forEach(x => {  //KW
                        sum += x;
                      });
                    }*/
                    x.value = "kw uh: " + parseFloat(x.value).toFixed(2).toString();// + " "+ x.und;
                    x.valueTotal = "kw total: " + parseFloat(x.valueTotal).toFixed(2).toString();//  + " "+ x.und;
                  }
            }

            if(x.nomenclatureSensorType == 'F'){
              if(!x.value){ x.value = "0"; }
              var porc = parseFloat(x.value);
              var porce = Math.round((parseFloat(x.value)*100)/1200);
              x.percentContent = porce;
              /*if(porc <= 0){
                x.imageGaugePercentContent = environment.storage + "/sensor/gauges/GaugePotFlujo1.png";
              }else if(porc <= 1500 && porc > 0){
                x.imageGaugePercentContent = environment.storage + "/sensor/gauges/GaugePotFlujo2.png";
              }else if(porc <= 2250 && porc > 1500){
                x.imageGaugePercentContent = environment.storage + "/sensor/gauges/GaugePotFlujo3.png";
              }else if(porc <= 3750 && porc > 2250){
                x.imageGaugePercentContent = environment.storage + "/sensor/gauges/GaugePotFlujo4.png";
              }else if(porc <= 5000 && porc > 3750){
                x.imageGaugePercentContent = environment.storage + "/sensor/gauges/GaugePotFlujo5.png";
              }else if(porc > 99){
                x.imageGaugePercentContent = environment.storage + "/sensor/gauges/GaugePotFlujo6.png";
              }*/
              x.imageGaugePercentContent = "../../../../../assets/pin-map/Cosa2.png";
              /*var sum = 0;
              if(x.graphSensor != null){
                var und = x.graphSensor[0].DataSets[0].Und;
                x.graphSensor[0].DataSets[0].data.forEach(x => {
                  sum += x;
                });
              }*/
              x.value = parseFloat(x.value).toFixed(2).toString() + " "+ x.und;
            }


              if(x.state == 1){
                this.sensorTypesCountEnabled.push(x.pin);
              }else{
                this.sensorTypesCountDisabled.push(x.pin);
              }

         }


              if(x.idSensors){
                if (x.idSensors.indexOf(',') > -1)
                {
                  x.sensors = x.idSensors.split(",");
                }else{
                  x.sensors = [x.idSensors];
                }
              }

            if(x.idActuators){
              if (x.idActuators.indexOf(',') > -1)
              {
                x.actuators = x.idActuators.split(",");
              }else{
                x.actuators = [x.idActuators];
              }
              var minC = parseFloat(x.minCapacity.toString());
              x.minCapacity = +(minC.toFixed(2)).toString();
              x.value = parseFloat(x.value).toFixed(2).toString();
              x.percentContent = +((((parseFloat(x.value.toString())/100) / (parseFloat(x.maxCapacity.toString())/100)))*100).toFixed(2);
              if(x.percentContent < 1){
                x.imageGaugePercentContent = environment.storage + "/actuator/gauges/gauge_percent0.png";
              }else if(x.percentContent >= 1 && x.percentContent <= 25){
                x.imageGaugePercentContent = environment.storage + "/actuator/gauges/gauge_percent25.png";
              }else if(x.percentContent > 25 && x.percentContent <= 50){
                x.imageGaugePercentContent = environment.storage + "/actuator/gauges/gauge_percent50.png";
              }else if(x.percentContent > 50 && x.percentContent <= 75){
                x.imageGaugePercentContent = environment.storage + "/actuator/gauges/gauge_percent75.png";
              }else if(x.percentContent > 75 &&  x.percentContent < 100){
                x.imageGaugePercentContent = environment.storage + "/actuator/gauges/gauge_percent85.png";
              }else if(x.percentContent >= 100){
                x.imageGaugePercentContent = environment.storage + "/actuator/gauges/gauge_percent100.png";
              }
            }
            iii++;
          });

          this.sensors = d;
          this.dataStreaming = d;
          this.dataStreamingColumn = d.filter(x => x.idActuatorType == 1 || x.idActuatorType == 3); //tanque || poza
          this.dataStreamingColumnActuators = d.filter(x => x.isActuator == 1 && x.idActuatorDataType != 2);
          if(this.showAllHeadquarters){
            var headquarters = JSON.parse(
              localStorage.getItem(AppConstants.Session.HEADQUARTERS)
            );
            var dataStreamingColumnHeadquartersActuators = [];
            var i = 0;
            headquarters.forEach(element => {
              console.log(element.name);
              if(this.dataStreamingColumnActuators[i]){
                this.dataStreamingColumnActuators[i].sensor= element.name;
                dataStreamingColumnHeadquartersActuators.push(this.dataStreamingColumnActuators[i]);
              }
              i++;
            });
            console.log("dataStreamingColumnHeadquartersActuators",dataStreamingColumnHeadquartersActuators);
            this.dataStreamingColumnActuators = dataStreamingColumnHeadquartersActuators;
          }

          this.dataStreamingColumnSensors = d.filter(x => x.isActuator != 1);
          this.dataStreamingColumnSensorsInit = this.dataStreamingColumnSensors;
          this.panelIOTService.setDataStreamingSensors(this.sensors);
          this.showSensorsGraphs = true;
          var _this = this;
          if(!this.isPhone && this.showTypeSelect == '1'){
                var canvas =  new fabric.Canvas("canvas");
                canvas.setWidth(1000);
                canvas.setHeight(500);
                _this.createMarkers();
                _this.createValueSensor();
          }

          _this.contentTotal = contentTotal.toFixed(2);
        }
        this.spinner.hide();
        this.loadData = false;



        this.sensorTypesCountEnabled.forEach(function(numero){
          repetidosEnabled[numero] = (repetidosEnabled[numero] || 0) + 1;
        });

        this.sensorTypesCountDisabled.forEach(function(numero){
          repetidosDisabled[numero] = (repetidosDisabled[numero] || 0) + 1;
        });


        Object.keys(repetidosEnabled).forEach(key => {
          this.sensorTypesCountEnabledObj.set(key,repetidosEnabled[key]);
        });
        Object.keys(repetidosDisabled).forEach(key => {
          this.sensorTypesCountDisabledObj.set(key,repetidosDisabled[key]);
        });
        /*
        console.log("repetidos enabled",this.sensorTypesCountEnabledObj);
        console.log("repetidos disabled",this.sensorTypesCountDisabledObj);
        console.log("qtyEnabled",this.sensorTypesCountEnabledObj);*/
        if(this.zoneSelect > 0 && !this.isTank && !this.isPoza){
          this.getGraphs();
        }
        this.test.emit(10);

        this.changeDetector.detectChanges();
      });
  }

  createMarkers() {
    var objects = this.canvas.getObjects();
    if(objects.lengt){
      for(var ii = 0; ii < objects.length; ii++){
        if(obj.id== objects[ii].id){
          this.canvas.remove(objects[ii]);
        }
      }
    }

    //console.log("sensors", this.sensors.length);
    for (var i = 0; i < this.sensors.length; i++) {
      var obj = this.sensors[i];
      this.newGroup(obj);
    }
  }

  createValueSensor() {
    this.removeActuatorsSensors();
    for (var i = 0; i < this.dataStreaming.length; i++) {
      var obj = this.dataStreaming[i];
      if(obj.idActuatorType != 2){ // no valvulas
        this.newValue(obj);
      }
    }
  }

  createLabelValueSensors() {
    this.removeLabelValueSensors();
    this.removeActuatorsSensors();
    for (var i = 0; i < this.dataStreaming.length; i++) {
      var obj = this.dataStreaming[i];
      if(obj.idActuatorType != 2){ // no valvulas
        this.newValue(obj);
      }
    }
  }

  removeLabelValueSensors(){
    if(this.canvas != null){
      var objects = this.canvas.getObjects();
      for (var i = 0; i < this.dataStreaming.length; i++) {
        var obj = this.dataStreaming[i];
        for(var ii = 0; ii < objects.length; ii++){
          if(obj.id +"_labelValue" == objects[ii].id){
            this.canvas.remove(objects[ii]);
          }
        }
      }
      this.canvas.renderAll();
    }
    if(this.canvas != null){
      var objects = this.canvas.getObjects();
      for (var i = 0; i < this.dataStreaming.length; i++) {
        var obj = this.dataStreaming[i];
        for(var ii = 0; ii < objects.length; ii++){
          if(obj.id +"_labelValue" == objects[ii].id){
            this.canvas.remove(objects[ii]);
          }
        }
      }
      this.canvas.renderAll();
    }
  }

  removeActuatorsSensors(){
    if(this.canvas != null){
      var objects = this.canvas.getObjects();
      for (var i = 0; i < this.dataStreaming.length; i++) {
        var obj = this.dataStreaming[i];
        for(var ii = 0; ii < objects.length; ii++){
          if(obj.id +"_value" == objects[ii].id){
            this.canvas.remove(objects[ii]);
          }
        }
      }
      this.canvas.renderAll();
    }
    if(this.canvas != null){
      var objects = this.canvas.getObjects();
      for (var i = 0; i < this.dataStreaming.length; i++) {
        var obj = this.dataStreaming[i];
        for(var ii = 0; ii < objects.length; ii++){
          if(obj.id +"_value" == objects[ii].id){
            this.canvas.remove(objects[ii]);
          }
        }
      }
      this.canvas.renderAll();
    }
  }

  newValue(obj) {
    if(obj.value == null || obj.value == undefined){ obj.value = 0; }
    //actuator
    if(obj.isActuator){
        if(obj.idActuatorType == 1){ // tanque
        var salveGuarda = "";
        if(!this.isGuardTotal){
          salveGuarda = "\n S:" + obj.minCapacity+ " TN";
        }
        if(obj.percentContent == undefined || !obj.percentContent){
          obj.percentContent = 0;
        }
        var text = new fabric.Text( "V:"+ parseFloat(obj.value).toFixed(2).toString() + " TN (" + obj.percentContent  +"%) \n CM:" + obj.maxCapacity + " TN"+salveGuarda + " \n D: "+obj.density,
        {
          selection: false,
          selectable: false,
          textBorderColor: this.color1,
          textShadow: this.color1,
          backgroundColor: 'transparent',
          fontSize: 12,
          fontWeight: 'bold',
          textBackgroundColor:'transparent',
          fill: this.color1,
          //fontSize: 20,
          strokeWidth: 0,
          selectionRadius: 20,
          originX: 'center',
          originY: 'center'
        }
          );

          var textBoundingRect = text.getBoundingRect();
          var background = new fabric.Rect({
            top: textBoundingRect.top,
            left: textBoundingRect.left,
            width: textBoundingRect.width,
            height: textBoundingRect.height,
            fill: 'transparent',//'#00000033',
            rx: 5,
            ry: 5,
            objectCaching: false,
          });
          var group = new fabric.Group([background,text], {
            left: parseFloat(obj.posX),
            top: parseFloat(obj.posY)-80,
            borderColor: this.color1,
            strokeWidth: 0,
            selectionRadius: 20,
            rx: 5,
            ry: 5,
            hasControls: false,
            hasRotatingPoint: false,
            id: obj.id+"_value",
            selectable: false,
            selection: false,
            isGraph: 0,
            fill:'red'
            });
            this.canvas.add(group);


            /* densidad */

            var imgDensity = "../../../../../assets/actuator/density/aceite.png";
            var _this= this;
            if(obj.density < 0.90 && obj.density > 0.93){ imgDensity = "../../../../../assets/actuator/density/agua.png";}
            new fabric.Image.fromURL(imgDensity,
              function(img) {
                var img1 = img.set({
                  originX: 'center',
                  originY: 'bottom',
                  top: -10,
                  scaleX: 1,
                  scaleY: 1
                });
                  var group = new fabric.Group([img1], {
                    left: parseFloat(obj.posX)-60,
                    top: parseFloat(obj.posY),
                    borderColor: 'transparent',
                    strokeWidth: 0,
                    selectionRadius: 20,
                    rx: 5,
                    ry: 5,
                    hasControls: false,
                    hasRotatingPoint: false,
                    id: obj.id+"_density",
                    selectable: false,
                    selection: false,
                    isGraph: 0
                  });
                  _this.canvas.add(group);
              });
      }
    }else{//sensor
      var color = "";
      if(obj.state == 1){
        color = "green";
      }else if(obj.state == 2){
        color = "yellow";
      }else{
        color = "red";
      }

      var _this = this;
      var text = new fabric.Text(obj.sensor, {
        textBorderColor: color, //this.color1,
          textShadow: color, //this.color1,
          backgroundColor: 'transparent',
          fontSize: 15,
          fontWeight: 'bold',
          textBackgroundColor:'transparent',
          fill: color,//this.color1,
        originX: 'center',
        originY: 'center',});
      var textBoundingRect = text.getBoundingRect();
      var background = new fabric.Rect({
        top: textBoundingRect.top,
        left: textBoundingRect.left,
        width: textBoundingRect.width,
        height: textBoundingRect.height,
        fill: '#00000033',
        rx: 5,
        ry: 5,
        objectCaching: false,
      });
      new fabric.Image.fromURL(obj.pin,
        function(img) {
          var img1 = img.set({
            originX: 'center',
            originY: 'bottom',
            top: -10,
            scaleX: 1,
            scaleY: 1
          });
            var group = new fabric.Group([text,background, img1], {
             /* left: obj.posX,
              top: obj.posY,
              borderColor: 'transparent',
              hasControls: false,
              hasRotatingPoint: false,
              id: obj.id,
              isGraph: 0*/
              left: parseFloat(obj.posX)+10,
              top: parseFloat(obj.posY)+20,
              borderColor: 'transparent',
              strokeWidth: 0,
              selectionRadius: 20,
              rx: 5,
              ry: 5,
              hasControls: false,
              hasRotatingPoint: false,
              id: obj.id+"_value",
              selectable: false,
              selection: false,
              isGraph: 0
            });
            _this.canvas.add(group);
        });
        /*
        var group = new fabric.Group([background,text], {


          });
          this.canvas.add(group);*/
          if(this.showLavelSensorsTable){
            var desc = "";
            if(obj.nomenclature.indexOf('RD') > -1){
              desc = "Altura: ";
            }
            var text2 = new fabric.Text(desc+obj.value.toString(),
            {
              backgroundColor: 'transparent',
              selection: false,
              selectable: false,
              textBorderColor: this.color1,
              textShadow: this.color1,
              textBackgroundColor:'transparent',
              fill: this.color1,
              fontSize: 20,
              strokeWidth: 0,
              selectionRadius: 20,
              originX: 'center',
              originY: 'center'
            }
              );
              var group2 = new fabric.Group([text2], {
                left: parseFloat(obj.posX)+20,
                top: parseFloat(obj.posY)-8,
                borderColor: 'transparent',
                strokeWidth: 0,
                selectionRadius: 20,
                rx: 5,
                ry: 5,
                hasControls: false,
                hasRotatingPoint: false,
                id: obj.id+"_labelValue",
                selectable: false,
                selection: false,
                isGraph: 0
                });
               this.canvas.add(group2);
          }


    }

  }

  newGroup(obj) {
      // text = new fabric.Text(obj.nomenclature, {selection: false,selectable: false,textBackgroundColor:obj.stateColor,fill: 'white', fontSize: 15, originX: 'center', originY: 'center'});

      var _this = this;
      if(obj.isActuator){
        var color = "";
        if(obj.state == 0){
          color = "green";
        }else if(obj.state == 1){
          color = "gray";
        }else if(obj.state == 2){
          color = "red";
        }
        var text = new fabric.Text(obj.nomenclature, {


          textBorderColor: color,
          textShadow: color,
          backgroundColor: 'transparent',
          fontSize: 15,
          fontWeight: 'bold',
          textBackgroundColor:'transparent',
          fill: color,
          originX: 'center',
          originY: 'center'});
        var img = "";



       /* if(obj.value != "" && obj.value != null && obj.imageActuator2 != "" && obj.imageActuator2 != null){
          if(obj.value == "1"){
            img = obj.imageActuator2;
          }
        }*/
        /*var scale = 0.7;
        if(obj.idActuatorType == 2){//valvula
          scale = 0.7;
        }*/

        var opacity = 1;
       /* if(obj.state == 4){
          opacity = 0.3;
        }*/

        var scale = 0.8;
        if(obj.idActuatorType != 3){ // No Pozas
         // scale = 0.5;
          new fabric.Image.fromURL(obj.imgActuator,
            function(img) {
              var img1 = img.set({
                originX: 'center',
                originY: 'bottom',
                top: -10,
                scaleX: scale,
                scaleY: scale
              });
                var group = new fabric.Group([text, img1], {
                  left: obj.posX,
                  top: obj.posY,
                  borderColor: 'transparent',
                  hasControls: false,
                  hasRotatingPoint: false,
                  selectable: false,
                  selection: false,
                  opacity: opacity,
                  id: obj.id,
                  isGraph: 0
                });
              // console.log("canvas group",group);
                _this.canvas.add(group);
                _this.nameMarker = '';
            });

        }
      }else{
        var _this = this;
        /* var text = new fabric.Text(obj.nomenclature, {textBackgroundColor:obj.stateColor,fill: 'white', fontSize: 15, originX: 'center', originY: 'center'});


       var group = new fabric.Group([text], {
          left: obj.posX,
          top: obj.posY,
          borderColor: 'transparent',
          hasControls: false,
          hasRotatingPoint: false,
          id: obj.id,
          isGraph: 0
          });
          this.canvas.add(group);*/
      }
      /*
      var group = new fabric.Group([text], {
      left: obj.posX,
      top: obj.posY,
      borderColor: 'transparent',
      hasControls: false,
      hasRotatingPoint: false,
      id: obj.id,
      selectable: false,
      selection: false,
      isGraph: 0
      });
      this.canvas.add(group);*/
  }


  newGraphSensor(obj) {
    var text = new fabric.Text(obj.nomenclature, {textBackgroundColor:'#1f5165',fill: 'white', fontSize: 15, originX: 'center', originY: 'center'});
    var group = new fabric.Group([text], {
    left: obj.posX,
    top: obj.posY + 50,
    borderColor: 'transparent',
    hasControls: false,
    hasRotatingPoint: false,
    id: obj.id
    });
    this.canvas.add(group);
}

  openEditModal(data){
      let dialogRef = this.dialog.open(SensorModalComponent, {
        data: {
          title: AppConstants.TitleModal.UPDATE_SENSOR,
          action: 0,
          gateways: this.gateways,
          headquarters: this.headquarters,
          idEnterprise: this.enterpriseSelect,
          idHeadquarter: this.headquarterSelect,
          idGateway: this.gatewaySelect,
          isAdminGys: this.isAdminGys,
          obj:data},
        width: '500px',
        hasBackdrop: true
      });
      dialogRef.afterClosed().subscribe(_ => {
        this.getList();
      });
  }

    changeHeadquarter(data) {
      this.headquarterSelect = data.value;
      this.getGateways();
      this.getZones();
    }

    changeGateway(data) {
      this.gatewaySelect = data.value;
      this.getList();
    }

    changeZone(data) {
      //this.spinner.show();
      this.showGraphSensor = false;
      this.zoneSelect = data.value;
      this.filterIOT = [];
      this.paneliotSearch = [];
      this.selectedPanelIOT = [];
      this.getSensors();

      if(this.showTypeSelect == "1" && this.zoneSelect == 0){
        this.displayListStadistics = 'none';
        this.showTypeSelect = "3";
      }

      this.selectSensorMenu = 0;
      if(this.showTypeSelect == '1'){
        var zone = this.zones.filter(x => x.id == this.zoneSelect);
        if(zone.length>0)
        {
          this.headquarterSelect = zone[0].idHeadquarter;
          var image = zone[0].image;
          this.imageZone = image;
        }else {
          this.imageZone = './assets/images/sin_image.jpg';
        }
        this.getList();
      }else{
        this.getList();
      }
    }

    changeImage(urlImage : string) {
        var _this = this;
        if(urlImage){
          fabric.Image.fromURL(urlImage, (img) => {
            img.set({
              opacity: 0.5,
              scaleX: _this.canvas.width / img.width,
              scaleY: _this.canvas.height / img.height,
            });
            _this.canvas.setBackgroundImage(img, _this.canvas.requestRenderAll.bind(_this.canvas));
          });
        }
    }

  openModal(id,nomenclature){
    document.getElementById('actuactorPanel'+id).style.display="initial";
    /*document.getElementById('chartLineStreaming'+id+"_").style.display="initial";*/
  }

  openModalGraph(item){
    let dialogRef = this.dialog.open(PanelIotActionModalComponent, {
      data: {
        title: AppConstants.TitleModal.UPDATE_SENSOR,
        action: 0,
        gateways: this.gateways,
        headquarters: this.headquarters,
        idEnterprise: this.enterpriseSelect,
        idHeadquarter: this.headquarterSelect,
        idGateway: this.gatewaySelect,
        isAdminGys: this.isAdminGys,
        idZone: this.zoneSelect,
        obj:item
      },
      panelClass: 'bg-modal-transparent' ,
      width: this.isPhone ? '250px':'300px',
      hasBackdrop: true
    });
    dialogRef.afterClosed().subscribe(_ => {
      if(_.change){
        this.getList();
      }
    });
  }

    showGraph(){
      var _this = this;
      this.canvas.on("mouse:up", function(e) {
        if(!_this.showGraphSensor && e.target != undefined && e.target != null){
          _this.showGraphSensor = true;
          // console.log("entraaaa if");
          _this.showSensorEdit = true;
          var dataS = null;
          //console.log("sensors",_this.sensors);
          _this.dataStreaming.forEach(g => {
            //console.log(g.id+"-----"+e.target.id+" || "+g.id + "_value"+"-----"+e.target.id);
            if ((g.id == e.target.id || g.id + "_value" == e.target.id) && g.idActuatorType != 3) { // && g.state == 0
              dataS = g;
              _this.openModal(g.id,g.nomenclature);
            }
          });
          _this.showGraphSensor = false;
          _this.showSensorEdit = false;
        }
      });
    }

    save(){
      var data = {
        isGuardTotal: this.isGuardTotal == true ? 1:0,
        guardTotal: this.guardTotal,
        idGateway: this.gatewaySelect,
        idUser: +localStorage.getItem(AppConstants.Session.USERID)
      }
      this.gatewayService.updateSettingGateway(data).subscribe((response) => {
        if(response.message == "" || !response.message){
          this.alertService.showMessage("Se actualizo el total guarda correctamente", "", MessageSeverity.success);
          this.getList();
        }else{
          this.alertService.showMessage("Ocurrió un problema al actualizar el guarda", "", MessageSeverity.error);
        }
      });
    }

    isGuardTotalSwitch(event: MatSlideToggleChange){
        if(event.checked){
          this.isGuardTotal = true;
        }else{
          this.isGuardTotal = false;
        }
    }

    mostrarSensor(item){
      this.selectSensorMenu = item.id;
      this.dataStreamingColumnSensors = this.dataStreamingColumnSensors.filter(x => x.id == item.id);
    }

    mostrarAllSensors(){
      this.selectSensorMenu = 0;
      this.dataStreamingColumnSensors = this.dataStreamingColumnSensorsInit;
    }

    refresh(){
      this.getList();
    }

    showPozas(idHeadquarter){
      this.showAllHeadquarters = this.showAllHeadquarters ? false : true;
      this.getList();
    }
}
